import {
  Component,
  HostListener,
  OnDestroy,
  OnInit,
  ViewChild,
  inject,
} from '@angular/core';
import { SiaSelectBoxComponent } from '@sia/inputs';
import { SiaI18nDirective, SiaSizeDetectorService } from '@sia/shared';
import {
  DxNumberBoxModule,
  DxScrollViewComponent,
  DxScrollViewModule,
  DxSwitchModule,
} from 'devextreme-angular';
import { SiaGridConfigTab } from '../sia-grid-config-tab/sia-grid-config-tab.component';

@Component({
  selector: 'sia-grid-config-adaptability',
  templateUrl: './sia-grid-config-adaptability.component.html',
  styleUrls: ['./sia-grid-config-adaptability.component.scss'],
  standalone: true,
  imports: [
    DxScrollViewModule,
    SiaI18nDirective,
    DxSwitchModule,
    SiaSelectBoxComponent,
    DxNumberBoxModule,
  ],
})
export class SiaGridConfigAdaptabilityComponent
  extends SiaGridConfigTab
  implements OnInit, OnDestroy
{
  @ViewChild(DxScrollViewComponent, { static: false })
  scroll: DxScrollViewComponent | undefined | null;
  gridConfColumnResizingModeTypes: string[] = ['nextColumn', 'widget'];
  private sizeDetector = inject(SiaSizeDetectorService);

  @HostListener('window:unload')
  ngOnDestroy() {
    if (this.scroll && this.scroll.instance) {
      this.scroll.instance.dispose();
      this.scroll = null;
    }
    this.gridConfColumnResizingModeTypes = [];
    super.ngOnDestroy();
  }
}
